<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center margin-right-sm ">
                <span>关键字：</span>
                <el-input style="width: 250px"  v-model="keyword" clearable placeholder="请输入关键字"></el-input>
                <span>商品：</span>
                <el-select v-model="good_id" filterable placeholder="请选择">
                    <el-option
                        v-for="item in goodsList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <template v-if="[3].includes(user.power)">
                    <span>社区：</span>
                    <el-select v-model="xiangmu_id" clearable filterable placeholder="请选择社区">
                        <el-option
                            v-for="item in projectList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </template>
                <span>状态：</span>
                <el-select v-model="state" clearable filterable placeholder="请选择状态">
                    <el-option
                        v-for="item in [
                            {name:'全部',id:''},
                            {name:'兑换中',id:0},
                            {name:'已兑换',id:1},
                            {name:'项目经理取消',id:2},
                            {name:'兑换人取消',id:3},
                        ]"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>

                <el-button class="margin-left-xs" type="primary" @click="hanldSearch">搜索</el-button>
                <el-button class="margin-left-xs" type="primary" @click="exportData">导出兑换记录</el-button>
            </div>
            <div class="flex align-center margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>

            </div>

            <el-table
                :data="residentList"
                alig="center"
                border
                header-row-class-name="table-header"
                row-class-name="table-row"
                style="width: 100%">
                <el-table-column align="center" label="序号" type="index" width="70"></el-table-column>
                <el-table-column label="所属社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="兑换人" prop="user_name"></el-table-column>
                <el-table-column label="商品名称" prop="good_name"></el-table-column>
                <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="时间" prop="create_time"></el-table-column>
                <el-table-column label="状态" prop="state_name"></el-table-column>
                <el-table-column label="操作" width="230">
                    <template slot-scope="scope">
                        <div class="table-operate" v-if="scope.row.state === 0">
                            <el-button
                                size="small"
                                type="primary"
                                @click="passItem(scope.row.id)"
                            >通过兑换
                            </el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="delItem(scope.row.id)"
                            >取消兑换
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                v-if="residentList.length > 0"
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all"
                layout="prev, pager, next, jumper"
                @current-change="getList">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {getXiangMuList} from "@/api/common";
import {getAllGood, getGoodOrderList, passOrder, refuseOrder} from "@/api/gzh";
import {upFeil} from "@/config";
import {getToken} from "@/utils/utils";

export default {
    name: "shopping",
    components: {},
    data() {
        return {
            projectList: [],
            goodsList: [],
            keyword: '',
            good_id: '',
            xiangmu_id: '',
            state: '', //状态 0兑换中 1已兑换 2项目经理取消 3兑换人取消
            page: 1,
            limit: 10,
            total: 0,
            residentList: [],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", '/home/gzh/goods', "双暖为老 / 商品管理 / 兑换记录", true);
        this.getList()
        this.getXiangMuList()
    },
    methods: {
        //  获取当前人员下的小区
        async getXiangMuList() {
            const project = await getXiangMuList()
            this.projectList = [{name: '全部', id: 0}, ...project.data]
            const data = await getAllGood()
            this.goodsList = [{name: '全部', id: 0}, ...data.data]
        },
        //  获取商品列表
        async getList() {
            let _data = await getGoodOrderList(
                this.keyword,
                this.good_id,
                this.xiangmu_id,
                this.state,
                this.page,
                this.limit,
            )
            this.residentList = _data.data
            this.total = _data.total_number
        },
        hanldSearch() {
            this.page = 1
            this.getList()
        },
        passItem(id){
            this.$confirm('您确定要通过该商品兑换吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.passOrder(id);
            });
        },
        async passOrder(id) {
            let _state = await passOrder(id);
            this.getList();
            this.$message.success(_state.info);
        },
        delItem(id){
            this.$confirm('您确定要取消该商品兑换吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.refuseOrder(id);
            });
        },
        async refuseOrder(id) {
            let _state = await refuseOrder(id);
            this.getList();
            this.$message.success(_state.info);
        },
        //  导出兑换记录
        exportData() {
            const token = getToken().token;
            const keyword = encodeURIComponent(this.keyword || '');
            const good_id = this.good_id || '';
            const xiangmu_id = this.xiangmu_id || '';
            const state = this.state === '' || this.state === null || this.state === undefined ? '' : this.state;
            window.open(`${upFeil}/index/export/exportGoodOrder?token=${token}&keyword=${keyword}&good_id=${good_id}&xiangmu_id=${xiangmu_id}&state=${state}`)
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>

</style>
